import React from "react";
import authService from "../services/authService";
import { useNavigate, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import "./AppLayout.css";

function AppLayout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const user = authService.getCurrentUser();

  const handleLogout = () => {
    authService.logout();
    navigate("/login");
  };

  // 🔹 Define páginas públicas (sem sidebar)
  const publicRoutes = ["/login", "/register", "/reset-password", "/forgot-password", "/verify-email"];
  const isPublicPage = publicRoutes.some((route) => location.pathname.startsWith(route));

  return (
    <div className="app-layout">
      {/* Sidebar só aparece se não for página pública */}
      {!isPublicPage && <Sidebar />}

      <div className="main-content">
        <header className="home-auth-buttons">
          {user ? (
            <>
              <span className="user-name">Olá, {user.name}</span>
              <button className="auth-button" onClick={handleLogout}>
                Logout
              </button>
            </>
          ) : (
            <>
              <button className="auth-button" onClick={() => navigate("/register")}>
                Registre-se
              </button>
              <button className="auth-button" onClick={() => navigate("/login")}>
                Login
              </button>
            </>
          )}
        </header>

        {/* Conteúdo principal */}
        <main>{children}</main>
      </div>
    </div>
  );
}

export default AppLayout;
